<script setup>
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {ref} from "vue";
import {ElLoading} from 'element-plus'
//表格数据
let annotationList = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(20)
//axios请求
import {inject} from 'vue'

const $axios = inject('$axios')

const annotationType = ref('')
const goSearch = ref('')

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function searchExpression() {
  annotationList.value = []
  goSearch.value = ''
  if (annotationType.value != '') {
    const loadingInstance = ElLoading.service({
      fullscreen: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)',
      lock: true
    })
    $axios.get('http://bioinfo-gdut.com:8000/api/show_' + annotationType.value).then((resp) => {
      if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
        annotationList.value = JSON.parse(JSON.stringify(resp.data))['list']
        loadingInstance.close()
      }
      goSearch.value = annotationType.value
    }).catch((err) => {
      loadingInstance.close()
      console.log(err)
    })
  }
}
</script>
<template>
  <div>
    <navbar/>
    <main class="profile-page">
      <section class="relative block h-500-px">
        <div
            class="absolute top-0 w-full h-full bg-center bg-cover"
            style="
            background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
          "
        >
          <span
              id="blackOverlay"
              class="w-full h-full absolute opacity-50 bg-black"
          ></span>
        </div>
        <div
            class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style="transform: translateZ(0);"
        >
          <svg
              class="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
          >
            <polygon
                class="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </section>
      <section class="relative py-16 bg-blueGray-200">
        <div class="container mx-auto px-4">
          <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64"
          >
            <div class="px-6">
              <div class="text-center mt-12 d-flex flex-column">
                <h3
                    class="text-4xl font-semibold leading-normal mb-4 text-blueGray-700"
                >
                  Annotation
                </h3>
                <div class="d-flex flex-row justify-content-center">
                  <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example"
                          v-model="annotationType"
                          style="width: 28%; color: #ccc;">
                    <option value="" disabled selected hidden>Select your annotation type</option>
                    <option value="PhylogeneticTree" style="color: black;">Phylogenetic Tree</option>
                    <option value="KeggAnnotation" style="color: black;">KEGG Annotation</option>
                    <option value="SwissProtAnnotation" style="color: black;">Swiss-Prot Annotation</option>
                    <option value="NrAnnotation" style="color: black;">Nr Annotation</option>
                    <option value="GoAnnotation" style="color: black;">Go Annotation</option>
                    <option value="InterproAnnotation" style="color: black;">Interpro Annotation</option>
                  </select>
                  <button
                      class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      @click="searchExpression">
                    Search
                  </button>
                </div>
                <div id="PhylogeneticTree_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='PhylogeneticTree'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed;font-size:18px">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Subfamily</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].subfamily }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="KeggAnnotation_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='KeggAnnotation'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 12%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 8%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">KO</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">Enzyme</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">EC</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">Pathway</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].ko }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].enzyme
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].ec
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].pathway }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="SwissProtAnnotation_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='SwissProtAnnotation'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Subject ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Enzyme</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Organism</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">identity</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Allignment Length</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Mismatches</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Gap Openning</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Q.start</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Q.end</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">S.start</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">S.end</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].subject_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].enzyme
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].organism
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].identity }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].alignment_length }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].mismatches }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].gap_openings }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].q_start }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].q_end }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].s_start }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].s_end }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="NrAnnotation_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='NrAnnotation'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Subject ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Enzyme</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Organism</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">identity</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Allignment Length</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Mismatches</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Gap Openning</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Q.start</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Q.end</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">S.start</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">S.end</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">E-value</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Bit Score</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].subject_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].enzyme
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].organism
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].identity }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].alignment_length }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].mismatches }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].gap_openings }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].q_start }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].q_end }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].s_start }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].s_end }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].e_value }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].bit_score }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="GoAnnotation_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='GoAnnotation'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">GO Annotation1</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">GO Annotation2</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">GO Annotation3</th>
                        <th scope="col" style="width: 15%" class="pe-0 ps-0">GO Annotation4</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].go_annotation1 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].go_annotation2
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].go_annotation3
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].go_annotation4
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="InterproAnnotation_tablePagination" class="row justify-content-center"
                     v-show="goSearch=='InterproAnnotation'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">ID</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Rename ID</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Length(aa)</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation1</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation2</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation3</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation4</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation5</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation6</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">InterPro annotation7</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in annotationList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].rename_id }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].length_aa_field }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation1 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].interpro_annotation2
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation3 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation4 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation5 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation6 }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].interpro_annotation7 }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="annotationList.length">
                    </el-pagination>
                  </div>
                </div>

              </div>
              <div class="mt-10 py-10 border-t border-blueGray-200 text-center">
                <div class="flex flex-wrap justify-center">
                  <div class="w-full lg:w-9/12 px-4">
                    <p class="mb-4 text-lg leading-relaxed text-blueGray-700">
                      This part is the result of the annotation of TPSs mined in 10 Lauraceae plants in various databases or software.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component/>
  </div>
</template>
